import React from "react"
import { useDispatch, useSelector } from "react-redux"
import { ModalFooter, Button } from "reactstrap"
import { sendEvent, updateVolleyballResult } from "../../api/socket/functions"
import { updateScoreCounter } from "../../redux/actions/actions"
import { getSportsConfig } from "../../utility/constants/sportConfig"
import { getEventMessage } from "../../utility/Utils"
import SetTimeModal from "./SetTimeModal/"

export default function ModalEventFooter({
	selectedPlayer,
	selectedEvent,
	dismissModal,
	followupPlayer,
	followupEvent,
	coordinates,
}) {
	const penaltiesOrEnd = useSelector((state) => state.penaltiesOrEnd)
	const homeTeamName = useSelector((state) => state.players.homeTeam.name)
	const dispatch = useDispatch()

	const onDone = (time, quarter) => {
		const params = {
			team: selectedPlayer.team,
			playerName: `(${selectedPlayer.tshirtNumber}) ${selectedPlayer.name} ${selectedPlayer.surname}`,
			_id: selectedPlayer.playerId,
			event: selectedEvent.name,
			comment: getEventMessage(
				selectedEvent,
				selectedPlayer,
				followupPlayer,
				followupEvent
			),
			followup_id: followupPlayer.playerId,
			followupEvent: followupEvent,
			time,
			quarter,
		}

		if (selectedEvent.increment) {
			const { incrementThroughSocket } = getSportsConfig(
				localStorage.getItem("sport")
			)

			if (incrementThroughSocket) {
				let point = selectedEvent.increment
				let team =
					selectedPlayer.team === homeTeamName ? "homeTeam" : "awayTeam"
				if (point < 0) {
					point *= -1
					team =
						selectedPlayer.team !== homeTeamName
							? "homeTeam"
							: "awayTeam"
				}

				const newScore = {
					homeTeam: JSON.parse(
						localStorage.getItem("score-homeTeam") ?? "0"
					),
					awayTeam: JSON.parse(
						localStorage.getItem("score-awayTeam") ?? "0"
					),
				}
				const newPoints =
					newScore[team] + point >= 0 ? newScore[team] + point : 0
				newScore[team] = newPoints
				updateVolleyballResult(newScore)
			} else {
				// if selected.increment is -1 then its a score for the opposite team
				if (selectedEvent.increment > 0) {
					const team =
						selectedPlayer.team === homeTeamName
							? "homeTeam"
							: "awayTeam"
					dispatch(updateScoreCounter(team, selectedEvent.increment))
					params.score = { team, value: selectedEvent.increment }
				} else {
					const team =
						selectedPlayer.team !== homeTeamName
							? "homeTeam"
							: "awayTeam"
					dispatch(updateScoreCounter(team, -selectedEvent.increment))
					params.score = { team, value: -selectedEvent.increment }
				}
			}
		}

		params.eventKey = selectedEvent.key
		params.playerId = selectedPlayer.playerId
		params.tshirtNumber = selectedPlayer.tshirtNumber
		if (coordinates) {
			params.coordinates = coordinates
		}
		if (followupPlayer?.playerId) {
			params.player2Id = followupPlayer.playerId
			params.tshirtNumber2 = followupPlayer.tshirtNumber
		}
		if (penaltiesOrEnd === "penalties") {
			params.time = "-"
			params.quarter = "P"
			sendEvent(params, true)
		} else {
			sendEvent(params, !!time && !!quarter)
		}

		dismissModal()
	}

	// Show the "Spremi" button if:
	// 1. The user selected an event and there was no followup to chose
	// 2. Or if the user selected an event and then the followup can be ignored
	// 3. Or if the user selected an event and then he chose a followup event/player
	const showDone =
		selectedEvent.name &&
		(selectedEvent.followup
			? selectedEvent.followup.allowIgnore ||
			  followupPlayer.name ||
			  followupEvent
			: true)

	return (
		<ModalFooter>
			{showDone ? (
				<>
					<p>
						{getEventMessage(
							selectedEvent,
							selectedPlayer,
							followupPlayer,
							followupEvent
						)}
					</p>
					{penaltiesOrEnd !== "end" ? (
						<Button color="primary" onClick={onDone}>
							Spremi
						</Button>
					) : (
						<SetTimeModal onParentDone={onDone} />
					)}
					<Button color="secondary" outline onClick={dismissModal}>
						Odustani
					</Button>
				</>
			) : (
				<Button color="secondary" onClick={dismissModal}>
					Odustani
				</Button>
			)}
		</ModalFooter>
	)
}
